/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgPhone(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M8.25 2.802c-.321-.276-.694-.302-1.43-.302H4.415a1.25 1.25 0 00-1.244 1.357 19.04 19.04 0 002.953 8.335l.004.006a18.75 18.75 0 005.77 5.77l.005.003a19.04 19.04 0 008.295 2.953 1.25 1.25 0 001.252-.745c.047-.107.087-.32.1-.695.01-.235.008-.476.006-.742 0-.155-.002-.32-.001-.495.003-.585-.003-1.138-.058-1.604-.06-.497-.163-.742-.238-.83a1.25 1.25 0 00-.776-.43 13.592 13.592 0 01-2.97-.74h-.002a1.25 1.25 0 00-1.317.28h-.002l-1.267 1.268a.75.75 0 01-.9.121 16.75 16.75 0 01-6.282-6.281.75.75 0 01.122-.901l1.267-1.267V7.86a1.25 1.25 0 00.28-1.317v-.002a13.59 13.59 0 01-.74-2.97 1.25 1.25 0 00-.422-.77zM6.889 1c.648 0 1.563-.002 2.339.665a2.75 2.75 0 01.93 1.7v.007c.12.904.34 1.792.66 2.646l-.703.262.702-.264a2.75 2.75 0 01-.619 2.901l-.003.003-.858.859a15.25 15.25 0 004.94 4.939l.858-.858.003-.003a2.75 2.75 0 012.9-.62 12.084 12.084 0 002.645.66h.007a2.75 2.75 0 011.714.946c.38.449.517 1.084.582 1.622.068.57.072 1.21.069 1.789l.001.428c.002.292.004.593-.006.858-.015.395-.057.855-.225 1.24a2.75 2.75 0 01-2.768 1.637l-.013-.001a20.54 20.54 0 01-8.954-3.185 20.25 20.25 0 01-6.226-6.226A20.54 20.54 0 011.679 4.01l-.001-.011A2.75 2.75 0 014.414 1H6.89z'
      />
    </svg>
  );
}

export default SvgPhone;
